import ShareableLinkRequestAccess from './ShareableLinkRequestAccess.component';

export default ShareableLinkRequestAccess;
